import axiosInstance from "./axios";

export const fetchWaterInTakeStatus = async () =>
  axiosInstance
    .get("/clients/water-in-take-tracking")
    .then((response) => response.data);

export const registerWaterInTake = async (requestData) =>
  axiosInstance
    .post("/clients/water-in-take-tracking", requestData)
    .then((response) => response.data);
